import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=0f867568"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports